"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingChecklistNeedCalibrationT = exports.TrackingChecklistNeedCalibration = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const tracker_id_js_1 = require("../../solarxr-protocol/datatypes/tracker-id.js");
class TrackingChecklistNeedCalibration {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackingChecklistNeedCalibration(bb, obj) {
        return (obj || new TrackingChecklistNeedCalibration()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackingChecklistNeedCalibration(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackingChecklistNeedCalibration()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackersId(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new tracker_id_js_1.TrackerId()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    trackersIdLength() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startTrackingChecklistNeedCalibration(builder) {
        builder.startObject(1);
    }
    static addTrackersId(builder, trackersIdOffset) {
        builder.addFieldOffset(0, trackersIdOffset, 0);
    }
    static createTrackersIdVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startTrackersIdVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endTrackingChecklistNeedCalibration(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackingChecklistNeedCalibration(builder, trackersIdOffset) {
        TrackingChecklistNeedCalibration.startTrackingChecklistNeedCalibration(builder);
        TrackingChecklistNeedCalibration.addTrackersId(builder, trackersIdOffset);
        return TrackingChecklistNeedCalibration.endTrackingChecklistNeedCalibration(builder);
    }
    unpack() {
        return new TrackingChecklistNeedCalibrationT(this.bb.createObjList(this.trackersId.bind(this), this.trackersIdLength()));
    }
    unpackTo(_o) {
        _o.trackersId = this.bb.createObjList(this.trackersId.bind(this), this.trackersIdLength());
    }
}
exports.TrackingChecklistNeedCalibration = TrackingChecklistNeedCalibration;
class TrackingChecklistNeedCalibrationT {
    constructor(trackersId = []) {
        this.trackersId = trackersId;
    }
    pack(builder) {
        const trackersId = TrackingChecklistNeedCalibration.createTrackersIdVector(builder, builder.createObjectOffsetList(this.trackersId));
        return TrackingChecklistNeedCalibration.createTrackingChecklistNeedCalibration(builder, trackersId);
    }
}
exports.TrackingChecklistNeedCalibrationT = TrackingChecklistNeedCalibrationT;
